export const TEAM_SETUP_STEPS = 4;

export const NDA_MODE = {
    NONE: 'NONE',
    EXISTING: 'EXISTING',
    UPLOAD: 'UPLOAD',
};

export const emptyNdaDraft = () => ({
    mode: NDA_MODE.NONE,
    ndaId: null,
    ndaVersionId: null,
    name: null,
    documentUrl: null,
    fileType: null,
});

export function filenameWithoutExtension(name) {
    const raw = String(name || '').trim();
    if (!raw) return '';
    const base = raw.split('/').pop() || raw;
    return base.replace(/\.[^/.]+$/, '').replace(/[-_]+/g, ' ').trim();
}

export function ndaFileType(nda, file) {
    if (nda?.file_type) return String(nda.file_type).toUpperCase();
    const name = file?.name || nda?.document || '';
    const ext = String(name).split('.').pop();
    if (!ext || ext === name) return 'FILE';
    return ext.toUpperCase();
}

export function formatNdaUploaded(created) {
    if (!created) return '';
    const date = new Date(created);
    if (Number.isNaN(date.getTime())) return '';
    return date.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
}

export function ndaMetaLine(nda, file) {
    const type = ndaFileType(nda, file);
    const uploaded = formatNdaUploaded(nda?.created);
    return uploaded ? `${type} · Uploaded ${uploaded}` : type;
}

export function draftFromNda(nda, mode = NDA_MODE.EXISTING) {
    if (!nda) return emptyNdaDraft();
    return {
        mode,
        ndaId: nda.id || nda.nda_id || null,
        ndaVersionId: nda.current_version_id || null,
        name: nda.name || filenameWithoutExtension(nda.document),
        documentUrl: nda.document || null,
        fileType: ndaFileType(nda),
    };
}

export function isNdaDraftReady(draft, { hasFile = false, name = '' } = {}) {
    if (!draft || draft.mode === NDA_MODE.NONE) return true;
    if (draft.mode === NDA_MODE.EXISTING) return Boolean(draft.ndaId);
    if (draft.mode === NDA_MODE.UPLOAD) return Boolean(draft.ndaId) || Boolean(hasFile && String(name || '').trim());
    return false;
}
